module.exports = new __parcel__URL__("lune.bc430886.svg").toString();